import React, { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";

import Icon from "../../../components/AppIcon";

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await api.get("api/testimonials?isFeatured=true&isActive=true"
        );
        setTestimonials(res.data || []);
      } catch (error) {
        console.error("Failed to load testimonials", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  if (loading) {
    return (
      <section className="py-16 text-center text-muted-foreground">
        Loading testimonials...
      </section>
    );
  }

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-success/10 text-success px-4 py-2 rounded-full mb-4">
            <Icon name="MessageSquare" size={16} />
            <span className="font-medium">Success Stories</span>
          </div>
          <h2 className="text-3xl font-heading font-bold">
            Hear From Our Successful Students
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t._id}
              className="bg-card rounded-xl p-6 shadow-md border border-border"
            >
              <div className="flex mb-3">
                {[...Array(t.rating || 5)].map((_, i) => (
                  <Icon key={i} name="Star" size={18} color="var(--color-accent)" />
                ))}
              </div>

              <p className="text-sm text-foreground mb-5">
                "{t.testimonialText}"
              </p>

              <div className="flex items-center gap-4 pt-4 border-t">
                <img
                  src={t.profileImage}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold">{t.name}</p>
                  <p className="text-sm text-muted-foreground">{t.role}</p>
                  <div className="flex gap-2 mt-1 text-xs">
                    <span className="bg-primary/10 text-primary px-2 py-0.5 rounded">
                      {t.company}
                    </span>
                    <span className="bg-success/10 text-success px-2 py-0.5 rounded">
                      {t.achievement}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
